import React from 'react';
import { QHeading } from '..';
import { DataProps } from '../../utils';

export type QTitleProps = DataProps & {
  children?: React.ReactNode;
};

export const QTitle: React.FC<QTitleProps> = ({ children, ...rest }) => (
  <QHeading size="lg" as="h1" {...rest}>
    {children}
  </QHeading>
);

QTitle.displayName = 'QTitle';
